import { render } from "./personalCenter.vue?vue&type=template&id=3dbe8bbe&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"

import "./personalCenter.vue?vue&type=style&index=0&id=3dbe8bbe&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbe8bbe"]])

export default __exports__